import { useQueryClient } from '@tanstack/react-query'
import { useForm } from '@tanstack/react-form'
import {
  getQparkStatusQueryKey,
  getStatusQueryKey,
  useQparkLogin,
} from '@api/generated'
import { errorMessage } from '@utils/errors'

/** Admin form to connect the Q-Park account the shared parking right belongs to. */
export function ConnectCard() {
  const queryClient = useQueryClient()
  const login = useQparkLogin({
    mutation: {
      onSuccess: () =>
        Promise.all([
          queryClient.invalidateQueries({ queryKey: getStatusQueryKey() }),
          queryClient.invalidateQueries({ queryKey: getQparkStatusQueryKey() }),
        ]),
    },
  })
  const form = useForm({
    defaultValues: { username: '', password: '' },
    onSubmit: ({ value }) => login.mutateAsync({ data: value }).catch(() => {}),
  })

  return (
    <div className="card bg-base-200 shadow-sm">
      <form
        className="card-body gap-4"
        onSubmit={(e) => {
          e.preventDefault()
          void form.handleSubmit()
        }}
      >
        <h2 className="card-title">Q-Park-Konto verbinden</h2>
        <p className="text-sm opacity-70">
          Verwende die E-Mail-Adresse und das Passwort des Q-Park-Kontos, dem
          die Parkberechtigung gehört. Das Passwort wird einmalig an Q-Park
          gesendet und nicht gespeichert; nur das daraus entstehende Login-Token
          wird verschlüsselt aufbewahrt.
        </p>
        <form.Field name="username">
          {(field) => (
            <label className="form-control">
              <span className="label-text mb-1">E-Mail</span>
              <input
                className="input input-bordered w-full"
                type="email"
                autoComplete="username"
                required
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
              />
            </label>
          )}
        </form.Field>
        <form.Field name="password">
          {(field) => (
            <label className="form-control">
              <span className="label-text mb-1">Passwort</span>
              <input
                className="input input-bordered w-full"
                type="password"
                autoComplete="current-password"
                required
                value={field.state.value}
                onChange={(e) => field.handleChange(e.target.value)}
              />
            </label>
          )}
        </form.Field>
        {login.isError && (
          <div role="alert" className="alert alert-error alert-soft text-sm">
            {errorMessage(login.error)}
          </div>
        )}
        <div>
          <button
            className="btn btn-primary"
            type="submit"
            disabled={login.isPending}
          >
            {login.isPending && <span className="loading loading-spinner" />}
            Verbinden
          </button>
        </div>
      </form>
    </div>
  )
}
